<template>
    <ul>
        <li v-for="order in orders">
            <router-link :to="`/store/${store.id}/order/${order.id}`">
                {{ order.id }} - {{ order.buyer_firstname }} {{ order.buyer_lastname }}
            </router-link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'OrderList',
    props: ['store', 'orders']
}
</script>
